import { Form, Modal, Space, Spin } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import React, {ReactElement, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import ILoanDrawdown from '~Api/Loan/ILoanDrawdown';
import { loanDrawdownDisbursalInstructedAction, loanDrawdownGetAction } from '~Loans/actions';
import { loanDrawdownSelector } from '~Loans/selectors';
import { IGlobalState } from '~reducer';
import DatePicker from '~UI/DatePicker';
import TimePicker from '~UI/TimePicker';
import { IDictionary } from '~utilities/IDictionary';

export default function DrawdownDisbursalInstructedModal(props: {
    loanDrawdownUuid: string;
    isOpen: boolean;
    onCancel: () => void;
}): ReactElement {
    const { loanDrawdownUuid, isOpen, onCancel } = props;

    const drawdown: ILoanDrawdown = useSelector((state: IGlobalState) => loanDrawdownSelector(state, loanDrawdownUuid));

    const [ instructedDate, setInstructedDate ] = useState<string>(null);
    const [ errors, setErrors] = useState<IDictionary<string>>({});

    const dispatch: Dispatch = useDispatch();

    useEffect(() => {
        if (!drawdown) {
            dispatch(loanDrawdownGetAction(loanDrawdownUuid));
        }
    }, [
        drawdown,
        dispatch,
        loanDrawdownUuid,
    ]);

    const validateinstructedDate: () => boolean = useCallback(() => {
        let error: string = null;

        if (!instructedDate) {
            error = 'Please enter the instructed date';
        }

        setErrors({
            ...errors,
            instructedDate: error,
        });

        return !error;
    }, [
        errors,
        instructedDate,
    ]);

    const disabledTime: (time: Dayjs) => boolean = useCallback((time: Dayjs) => {
        return time && (time.isAfter(dayjs(), 'second') || time.isBefore(dayjs(drawdown.qsReceivedTime)));
    }, [drawdown.qsReceivedTime]);

    const onClickOk: () => void = useCallback(() => {
        let valid: boolean = true;

        valid = validateinstructedDate() && valid;

        if (!valid) {
            return;
        }

        dispatch(loanDrawdownDisbursalInstructedAction(drawdown.uuid, instructedDate));
        onCancel();
    }, [
        drawdown,
        dispatch,
        instructedDate,
        onCancel,
        validateinstructedDate,
    ]);

    const onChangeinstructedDate: (date: Dayjs) => void = useCallback((date: Dayjs) => {
        setInstructedDate(date ? dayjs(`${date.format('YYYY-MM-DD')} ${dayjs(instructedDate || undefined).format('HH:mm')}`).format() : null);
    }, [instructedDate]);

    const onChangeInstructionTime: (time: Dayjs) => void = useCallback((time: Dayjs) => {
        setInstructedDate(time ? dayjs(`${dayjs(instructedDate || undefined).format('YYYY-MM-DD')} ${time.format('HH:mm')}`).format() : null);
    }, [instructedDate]);

    if (!drawdown) {
        return (
            <Modal
                footer={false}
                onCancel={onCancel}
                open={isOpen}
                title='Disbursal Instructed'
                wrapClassName='loan-drawdown-disbursal-instructed-modal'
                width={640}
            >
                <Spin/>
            </Modal>
        );
    }

    return (
        <Modal
            okText='Disbursal Instructed'
            onCancel={onCancel}
            onOk={onClickOk}
            open={isOpen}
            title='Disbursal Instructed'
            wrapClassName='loan-drawdown-disbursal-instructed-modal'
            width={640}
        >
            <Form.Item
                label='Instructed Date'
                className='instructed-date'
                help={errors.instructedDate}
                validateStatus={errors.instructedDate && 'error'}
            >
                <Space>
                    <DatePicker
                        className='instructed-date-pick-date'
                        disabledDate={disabledTime}
                        onChange={onChangeinstructedDate}
                        format='DD/MM/YYYY'
                        value={instructedDate ? dayjs(instructedDate) : null}
                    />
                    <TimePicker
                        className='instructed-date-pick-time'
                        disabledDate={disabledTime}
                        onChange={onChangeInstructionTime}
                        value={instructedDate ? dayjs(instructedDate) : null}
                        format='H:mm'
                    />
                </Space>
            </Form.Item>
        </Modal>
    );
}